import React from "react";
import {
  Box,
  Paper,
} from "@mui/material";

// 左右表示用のグラデーションボーダー（余白あり）
export const GradientBorderBox: React.FC<{
    children: React.ReactNode;
    sx?: any;
    innerRef?: React.RefObject<HTMLDivElement | null>;
  }> = ({ children, sx = {}, innerRef }) => {
    return (
      <Box ref={innerRef}
        sx={{
          position: "relative",
          background: "linear-gradient(to bottom, #a8a8d4, #ffffff)",
          padding: "2px",
          borderRadius: "10px",
          ...sx,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <Paper
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              borderRadius: "8px",
              padding: "8px", // Reduced padding
            }}
          >
            {children}
          </Paper>
        </Box>
      </Box>
    );
  };